import comp from "./GenericCard";
export default comp;
